import { API } from "services/api";

export type SituacaoPedido = "PRONTO" | "CORRIGIDO" | "AJUSTE" | "DUPLICADO";

export type PedidoDaPrevia = {
  pedido_ref: string;
  comprador: string | null;
  /** ISO-2 já normalizado, ou null quando não foi possível reconhecer. */
  pais: string | null;
  pais_original: string | null;
  itens: number;
  moeda: string | null;
  total: number;
  situacao: SituacaoPedido;
  motivo: string | null;
  correcoes: string[];
};

export type PreviaImportacao = {
  ok: boolean;
  arquivo: { nome: string; linhas: number };
  pedidos: PedidoDaPrevia[];
  resumo: { total: number; prontos: number; ajuste: number; duplicados: number };
  /** Linhas já processadas, devolvidas para a confirmação não reenviar o arquivo. */
  linhas: unknown[];
};

/** Lê a planilha e classifica cada pedido. Não grava nada. */
export const previaImportacao = async (arquivo: File): Promise<PreviaImportacao> => {
  const form = new FormData();
  form.append("file", arquivo);

  const { data } = await API.post<PreviaImportacao>("/api/importacao/previa", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

/** Grava os pedidos escolhidos na prévia. */
export const confirmarImportacao = async (linhas: unknown[], refs: string[]) => {
  const { data } = await API.post<{
    ok: boolean;
    created: number;
    skipped: number;
    grouped_orders: number;
  }>("/api/importacao/confirmar", { linhas, refs });
  return data;
};

/**
 * Cabeçalhos que o leitor de planilha reconhece (services/fieldMap.js no
 * backend). São os mesmos do export de pedidos da Shopify em português.
 *
 * HS Code não está aqui de propósito: ele não vem da planilha de pedidos, vem
 * do cadastro de produtos, casado pelo SKU.
 */
export const COLUNAS_MODELO = [
  "Nome do pedido",
  "Moeda",
  "Total",
  "Nome do envio",
  "E-mail",
  "Telefone (envio)",
  "Endereço de envio 1",
  "Endereço de envio 2",
  "Cidade (envio)",
  "Estado (envio)",
  "CEP (envio)",
  "País (envio)",
  "Item do pedido - Nome",
  "Item do pedido - SKU",
  "Item do pedido - Quantidade",
  "Item do pedido - Preço",
];

const EXEMPLO = [
  "#1012",
  "USD",
  "128.40",
  "Emily Carter",
  "emily@email.com",
  "+1 305 555 0142",
  "1450 Brickell Ave",
  "Apt 2204",
  "Miami",
  "FL",
  "33131",
  "Estados Unidos",
  "Camiseta algodão",
  "SKU-001",
  "2",
  "64.20",
];

/** Monta o CSV modelo com uma linha de exemplo preenchida. */
export const montarCsvModelo = (): Blob => {
  const linhas = [COLUNAS_MODELO.join(","), EXEMPLO.map((c) => `"${c}"`).join(",")];
  // BOM para o Excel abrir os acentos certos.
  return new Blob([`﻿${linhas.join("\r\n")}\r\n`], {
    type: "text/csv;charset=utf-8",
  });
};
